import { PluginHelper } from "./PluginHelper";
import { logIssue } from "./layoutLogger";
export function computeViewLevelOfAttribute(cell, attributes) {
    var _a;
    const defaultResult = {
        viewLevel: 0,
        requiredViewLevel: Number.MAX_SAFE_INTEGER,
    };
    if (!PluginHelper.isAttributePlugin(cell)) {
        return defaultResult;
    }
    const props = PluginHelper.getPluginProps(cell);
    const attribute = attributes.find((attribute) => attribute.id === props.identifier);
    if (!attribute) {
        logIssue(`Attribute from not found in configuration state`, props.identifier);
        return defaultResult;
    }
    if (props.viewLevel == null) {
        logIssue(`Attribute has no viewLevel defined, assuming 1`, attribute.id);
    }
    const viewLevel = (_a = props.viewLevel) !== null && _a !== void 0 ? _a : 1;
    // it does not matter if it is required or complete
    if (!attribute.isActive || !attribute.isVisible) {
        return { viewLevel, requiredViewLevel: Number.MAX_SAFE_INTEGER };
    }
    // view level does count for max viewLevel calculation
    if (attribute.isRequired && !attribute.isComplete) {
        return { viewLevel, requiredViewLevel: viewLevel };
    }
    // view level does NOT count for max viewLevel calculation
    return { viewLevel, requiredViewLevel: Number.MAX_SAFE_INTEGER };
}
//# sourceMappingURL=computeViewLevelOfAttribute.js.map